<template>
  <div v-if="testimonial" class="flex flex-col items-center mx-5 sm:mx-10 md:mx-20">
    <div
      v-if="testimonial.body"
      data-test-id="body"
      class="leading-normal fluid-xl font-medium text-center lg:w-2/3"
      :class="{ 'text-white': backgroundBlack }"
      v-html="testimonial.body"
    ></div>
    <div
      v-if="testimonial.authorImage && testimonial.authorImage[0]"
      class="lg:w-1/4 flex justify-center"
      data-test-id="author-image"
    >
      <CldnImg
        :src="testimonial.authorImage[0].url"
        sizes="96px sm:96px md:96px lg:96px xl:96px 2xl:96px"
        crop="fill"
        :alt="testimonial.authorName ? testimonial.authorName : testimonial.authorImage[0].title"
        class="rounded-full mt-5 w-24 h-24 object-cover object-center"
      />
    </div>
    <p
      v-if="testimonial.authorName"
      data-test-id="author"
      class="testimonial-font-medium leading-normal fluid-base font-light mt-5 mx-auto"
      :class="{ 'text-br-green-light': backgroundBlack }"
    >
      {{ testimonial.authorName }}
    </p>
  </div>
</template>

<script>
import CldnImg from '@/components/CldnImg';

export default defineNuxtComponent({
  name: 'Testimonial',

  components: { CldnImg },

  props: {
    testimonial: {
      type: Object,
      default: () => null,
    },
    backgroundBlack: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style scoped>
@reference "~/assets/css/main.css";
.testimonial-font-medium {
  @apply font-medium;
}
</style>
